/* istanbul ignore file */
import React from "react";
import { ToelichtingArbeidsongeschiktheidHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { ReactElement } from "react-markdown/lib/react-markdown";
import { InkomensanalyseTabelArbeidsongeschiktheid } from "../../../scenarios/arbeidsongeschiktheid-drawer";
import { Motivering } from "../../../components/Motivering";

export const ScenarioArbeidsongeschiktheidChapter = ({
  scenarioArbeidsongeschiktheid,
  selectedAanvrager,
}: {
  scenarioArbeidsongeschiktheid: ToelichtingArbeidsongeschiktheidHoofdstuk;
  selectedAanvrager?: "Aanvrager1" | "Aanvrager2";
}): ReactElement => {
  const dashboardSettings =
    scenarioArbeidsongeschiktheid.dashboard?.arbeidsongeschiktheid;
  const klantVolgNummer = selectedAanvrager === "Aanvrager2" ? 2 : 1;
  const motivering =
    scenarioArbeidsongeschiktheid.motivering?.find(
      (x) => x.klantVolgnummer === klantVolgNummer
    ) || null;
  const isScenarioForAanvrager1 = selectedAanvrager === "Aanvrager1";

  const personWithDisability = isScenarioForAanvrager1
    ? motivering?.klantNaamAanvrager || "Aanvrager"
    : motivering?.klantNaamPartner || "Partner";

  const motiveringKeuzes =
    selectedAanvrager === "Aanvrager1"
      ? scenarioArbeidsongeschiktheid?.motiveringKeuzesAanvrager1
      : scenarioArbeidsongeschiktheid?.motiveringKeuzesAanvrager2;

  return (
    <Chapter>
      <div className="break-avoid">
        <Heading
          level={3}
          text={`Bij arbeidsongeschiktheid van ${personWithDisability}`}
        />
        <Motivering
          wens={motiveringKeuzes?.wensen ?? null}
          advies={motiveringKeuzes?.advies ?? null}
          keuze={motiveringKeuzes?.keuze ?? null}
        />
      </div>
      {motivering && dashboardSettings && (
        <InkomensanalyseTabelArbeidsongeschiktheid
          motiveringOutput={motivering}
          dashboardSettings={dashboardSettings}
          selectedAanvrager={selectedAanvrager}
        />
      )}
    </Chapter>
  );
};
